import makeStyles from '@material-ui/core/styles/makeStyles';

import { colors } from '../../assets';

export const useStyles = makeStyles(theme => ({
  dropdown: {
    zIndex: theme.zIndex.modal,
    width: ({ dropdownWidth }: { dropdownWidth?: number }) => dropdownWidth,
  },
  dropdownItem: {
    paddingRight: 15,
    whiteSpace: 'normal',
    color: colors.grey120,
    fontSize: 14,
    lineHeight: '24px',
    padding: '8px 16px',
    letterSpacing: '0.15px',
    overflow: 'hidden',

    '&:nth-child(odd)': {
      backgroundColor: colors.grey10,
    },

    '&:hover': {
      backgroundColor: colors.grey20,
    },
  },
  activeDropdownItem: {
    '&&': {
      backgroundColor: colors.grey20,
    },
  },
  mainText: {
    fontWeight: 'bold',
    fontSize: 16,
  },
  searchQueryMatch: {
    color: colors.grey190,
  },
  input: {
    '&.noBottomRadius': {
      borderRadius: '4px 4px 0px 0px',
    },

    '& .MuiInputBase-input.MuiInputBase-inputAdornedEnd': {
      paddingRight: 0,
    },

    [theme.breakpoints.down('xs')]: {
      '& .MuiInputBase-input.MuiInputBase-inputAdornedStart': {
        paddingLeft: 0,
      },
    },
  },
  checkIcon: {
    fontSize: '24px',
    color: colors.functionals.success,
  },
  paper: {
    borderRadius: '0px 0px 4px 4px',
    overflow: 'hidden',
  },
}));
